import React from 'react';
import { CheckCircle } from 'lucide-react';

const Services = () => {
  return (
    <section className="py-16 bg-white" id="services">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Coach HT's <span className="text-primary-500">Specialties</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Expert guidance in nutrition, fitness training, and the PHYT method
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Service 1 */}
          <div className="bg-primary-50 rounded-xl p-8 shadow-sm hover:shadow-md transition duration-300 flex flex-col h-full">
            <h3 className="text-2xl font-bold mb-6 text-primary-500">Nutrition Coaching</h3>
            <p className="text-gray-700 mb-6">
              Comprehensive meal planning and nutrition guidance to help you achieve your health and fitness goals
            </p>
            
            <h4 className="font-bold text-gray-900 mb-4">What's included:</h4>
            <ul className="space-y-3 mb-8 flex-grow">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Personalized meal plans</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Nutrition education and guidance</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Recipe database and shopping guides</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Ongoing support and accountability</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Sustainable eating habit development</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Progress tracking and adjustments</p>
              </li>
            </ul>
            
            <div className="mt-auto">
              <a
                href="#packages"
                className="inline-block w-full text-center bg-primary-500 text-white text-lg px-6 py-4 rounded-xl hover:bg-primary-600 transition duration-300 shadow-lg"
              >
                View Programs
              </a>
            </div>
          </div>

          {/* Service 2 */}
          <div className="bg-primary-50 rounded-xl p-8 shadow-sm hover:shadow-md transition duration-300 flex flex-col h-full">
            <h3 className="text-2xl font-bold mb-6 text-primary-500">Fitness Training</h3>
            <p className="text-gray-700 mb-6">
              Personalized training programs focused on proper form, alignment, and the PHYT method for maximum results
            </p>
            
            <h4 className="font-bold text-gray-900 mb-4">What's included:</h4>
            <ul className="space-y-3 mb-8 flex-grow">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Individualized training programs</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Form and technique assessment</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">PHYT method training</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Fat loss and body transformation</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">In-person and small group sessions</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Flexible scheduling options</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-500">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Progress monitoring and adjustments</p>
              </li>
            </ul>
            
            <div className="mt-auto">
              <a
                href="#packages"
                className="inline-block w-full text-center bg-primary-500 text-white text-lg px-6 py-4 rounded-xl hover:bg-primary-600 transition duration-300 shadow-lg"
              >
                View Programs
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center bg-primary-100 p-8 rounded-xl">
          <blockquote className="text-2xl italic text-gray-700 mb-6">
            "Heather is INCREDIBLE! I've been working with her for two months and the changes are extraordinary - my mobility, flexibility, and strength have progressed so much."
          </blockquote>
          <div className="text-primary-500 font-bold">- Ribkah N, PHYT Client</div>
        </div>
      </div>
    </section>
  );
};

export default Services;